import { render, staticRenderFns } from "./BasalamCategoryAttributes.vue?vue&type=template&id=473eadc2&scoped=true"
import script from "./BasalamCategoryAttributes.vue?vue&type=script&lang=js"
export * from "./BasalamCategoryAttributes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473eadc2",
  null
  
)

export default component.exports